import LegalPageLayout from '../components/LegalPageLayout';
import { VULNERABILITY_DISCLOSURE_POLICY } from '../constants/legal';

function VulnerabilityDisclosurePolicy() {
  return <LegalPageLayout policy={VULNERABILITY_DISCLOSURE_POLICY} />;
}

export default VulnerabilityDisclosurePolicy;
